import { Record, Resource, SDK } from '@redge-media/fo-js-sdk';

const ProductRelated = Resource.extend({
  endpoint: '/products',
  constructor: function ProductRelated(product = {}, type) {
    Resource.call(this);

    if (!product.id) {
      throw new Error('product id is obligatory');
    }

    if (!type) {
      throw new Error('related type is obligatory');
    }

    this.type = type;
    this.id = product.live ? product.live.id : product.id;
  },

  createRecord(props = {}, opts = {}) {
    if (props instanceof Record) {
      return props;
    }

    return SDK.factory.resolve(props, opts);
  },

  getPath() {
    return `${this.endpoint}/${this.id}/related/${this.type}`;
  },
});

export default ProductRelated;
